import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import { Button, Tooltip, Modal } from "antd";
import { BookOutlined, BookFilled } from "@ant-design/icons";

const OathTaking = ({ caseId, isSessionActive, currentUserRole, oathRoles }) => {
  const [isOatModalOpen, setIsOatModalOpen] = useState(false);

  const socket = useRef(
    io("https://backend-kyw8.onrender.com/cases", {
      autoConnect: false,
      extraHeaders: { case_id: caseId },
    })
  );

  useEffect(() => {
    if (isSessionActive && !socket.current.connected) {
      socket.current.connect();
      console.log("Oath socket connected");

      socket.current.on("connect", () => {
        socket.current.emit("join-room", caseId); // Ensure the client joins the room
        console.log(`Joined case room: ${caseId}`);
      });
      
      socket.current.on("taking-oath", (data) => {
        if(data==="Witness is taking oath by Bible"){
           window.dispatchEvent(new CustomEvent("Bible-oath-taking-triggered"));
        }else if (data==="Witness is taking oath by Quran"){
          window.dispatchEvent(new CustomEvent("Quran-oath-taking-triggered")); 
        } else if (data==="Witness Affirmed"){
		  window.dispatchEvent(new CustomEvent("Affirm-oath-taking-triggered"));
		}
      });
      
      socket.current.on("oath-taken", () => {
        window.dispatchEvent(new CustomEvent("end-oath-triggered"));
      });
    }

    return () => {
      if (socket.current.connected) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        socket.current.disconnect();
        console.log("Oath socket disconnected");
      }
    };
  }, [caseId, isSessionActive]);

  const handleSwear = (data:any, eventName:any) => {
    if (!caseId) return;

    setIsOatModalOpen(false);
    socket.current.emit("taking-oath", caseId, data); // Emit the event directly
    console.log("Taking oath:", data);

    window.dispatchEvent(new CustomEvent(eventName));
  };

  const endOat = () => {
    if (!caseId) return;

    const data = "Witness has finished swearing oath";
    socket.current.emit("oath-taken", caseId, data);
    console.log("Oath successfully taken");
    window.dispatchEvent(new CustomEvent("end-oath-triggered"));
  };

  return (
    <div>
      {currentUserRole === "COURT_REGISTRAR" && (
        <>
          <Tooltip title="Take Oath">
            <Button icon={<BookFilled />} onClick={() => setIsOatModalOpen(true)} />
          </Tooltip>
          <Tooltip title="End Oath">
            <Button icon={<BookOutlined />} onClick={endOat} />
          </Tooltip>
        </>
      )}

      <Modal
        title="Take Oath"
        open={isOatModalOpen}
        onCancel={() => setIsOatModalOpen(false)}
        footer={[<Button key="close" onClick={() => setIsOatModalOpen(false)}>Close</Button>]}
      >
        <div className="flex flex-col gap-3 mt-5">
          <Button className="w-full text-left font-semibold" onClick={() => handleSwear("Witness is taking oath by Bible", "Bible-oath-taking-triggered")}>
            📖 Swear By Bible
          </Button>
          <Button className="w-full text-left font-semibold" onClick={() => handleSwear("Witness is taking oath by Quran", "Quran-oath-taking-triggered")}>
            ☪️ Swear By Qur'an
          </Button>
		      <Button className="w-full text-left font-semibold" onClick={() => handleSwear("Witness Affirmed", "Affirm-oath-taking-triggered")}>
             Affirmation
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default OathTaking;
